import React from 'react'
import { Badge, Whisper, Tooltip } from 'rsuite'
import { Cell } from 'rsuite-table'

type RowData = {
  [key: string]: string | boolean
}

type PaymentStatusCellProps = {
  rowData?: RowData
  dataKey: string
}

const defaultProps = {
  rowData: undefined
}

const STATUS_CONFIG: Record<
  string,
  { label: string; bg: string; color: string }
> = {
  PENDING: { label: 'Pending', bg: '#FFF8E1', color: '#F9A825' },
  SUCCESS: { label: 'Success', bg: '#ECFDF3', color: '#14BA6D' },
  FAILED: { label: 'Failed', bg: '#FDE8E8', color: '#D32F2F' },
  CANCELLED: { label: 'Cancelled', bg: '#E9EDF5', color: '#6C778B' },
  PROCESSING: { label: 'Processing', bg: '#E8F4FD', color: '#1976D2' }
}

const FALLBACK_CONFIG = { label: '-', bg: '#E9EDF5', color: '#6C778B' }

const PaymentStatusCell: React.FC<PaymentStatusCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const status = rowData?.[dataKey] as string
  const config = STATUS_CONFIG[status] ?? {
    ...FALLBACK_CONFIG,
    label: status ?? '-'
  }

  return (
    <Whisper
      placement="bottom"
      trigger="hover"
      speaker={<Tooltip>{config.label}</Tooltip>}
    >
      <Cell {...props}>
        <Badge
          style={{
            backgroundColor: config.bg,
            color: config.color,
            padding: '3px 10px 3px 5px',
            whiteSpace: 'nowrap'
          }}
          content={
            <>
              <Badge
                style={{ backgroundColor: config.color, margin: '0 7px' }}
              />
              {config.label}
            </>
          }
        />
      </Cell>
    </Whisper>
  )
}

PaymentStatusCell.defaultProps = defaultProps

export default PaymentStatusCell
